import React from 'react';
import styled from 'react-emotion';

export const AspectRatioImgContainer = styled.div`
  position: relative;
  &:before {
    display: block;
    content: "";
    width: 100%;
    padding-top: calc(${props => props.ratio} * 100%);
  }
  > .inner {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
  }
  
  img {
    width: 80%;
    height: 80%;
    margin-left: 10%;
    margin-top: 8%;
    object-fit: contain;
  }
`
const AspectRatioImage = ({ ratio = 1, src, className, style }) => {
  return (
    <AspectRatioImgContainer ratio={ratio} className={className} style={style}>
      <div className="inner">
        <img src={src} />
      </div>
    </AspectRatioImgContainer>
  )
};

export default AspectRatioImage;


// WEBPACK FOOTER //
// ./src/components/AspectRatioImage.js